import Delivery from "../assets/projects/Delivery.png";
import Delivery2 from "../assets/projects/Delivery(2).png";
import Delivery3 from "../assets/projects/Delivery(3).png";
import Delivery4 from "../assets/projects/Delivery(4).png";
import Delivery5 from "../assets/projects/Delivery(5).png";

// import mail4 from "../assets/projects/mail4.png";
export const data = [
  {
    id: 1,
    name: "GreenScape",
    image: Delivery,
    github: "https://greenscape-beige.vercel.app/",
    description:
      "About GreenScape: A premium landscaping portfolio and service website featuring scroll animations, dynamic routing, and a mobile-first design built on Next.js and Tailwind CSS.",
    type: "fullstack",
    gallery: [Delivery, Delivery2, Delivery3, Delivery4, Delivery5],
  },
];
